// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealEntity from './entities/appeal.json';
import appealMenu from '../pages/appeal/menu.json';
import appealFullForm from '../pages/appeal/forms/full.json';
import appealContextForm from '../pages/appeal/forms/context.json';
import appealMiniForm from '../pages/appeal/forms/mini.json';
import appealLookupForm from '../pages/appeal/forms/lookup.json';
import appealTableView from '../pages/appeal/views/table.json';
import appealStagesView from '../pages/appeal/views/stages.json';
import appealCardsView from '../pages/appeal/views/cards.json';
import appealInlineView from '../pages/appeal/views/inline.json';
import appealBacklogView from '../pages/appeal/views/backlog.json';
import appealSplitView from '../pages/appeal/views/split.json';
import appealCalendarView from '../pages/appeal/views/calendar.json';
import appealDashboardView from '../pages/appeal/views/dashboard.json';

/** Тип запису «Звернення» зі сторінками пакета: меню, форми та подання з pages/appeal/. */
export const appealDefinition: IRecordTypeDefinition = {
  ...appealEntity,
  views: assembleViewSet({
      table: appealTableView,
      stages: appealStagesView,
      cards: appealCardsView,
      inline: appealInlineView,
      backlog: appealBacklogView,
      split: appealSplitView,
      calendar: appealCalendarView,
      dashboard: appealDashboardView,
  }),
  form: appealFullForm,
  forms: { full: appealFullForm, context: appealContextForm, mini: appealMiniForm, lookup: appealLookupForm },
  menu: appealMenu,
} as IRecordTypeDefinition;
